(function () {
if (typeof window.closepopup !== 'function') {
  window.closepopup = function () {
    document.querySelectorAll('.body-blackout').forEach(function (blackout) {
      blackout.classList.remove('is-blacked-out');
    });
    document.querySelectorAll('.popup-modal').forEach(function (modal) {
      modal.classList.remove('is--visible');
    });
  };
}

function openMiniSplitPopup(modalName) {
  if (typeof window.closepopup === 'function') {
    window.closepopup();
  }

  var modal = document.querySelector('[data-popup-modal="' + modalName + '"]');
  if (!modal) return;

  var modalWrapper = modal.parentElement;
  var blackout = modalWrapper ? modalWrapper.querySelector('.body-blackout') : null;
  if (blackout) {
    blackout.classList.add('is-blacked-out');
  }
  modal.classList.add('is--visible');
}

if (typeof window.openBTUpopup !== 'function') {
  window.openBTUpopup = function () {
    openMiniSplitPopup('btu-modal');
  };
}

if (typeof window.opentypepopup !== 'function') {
  window.opentypepopup = function () {
    openMiniSplitPopup('type-modal');
  };
}

if (typeof window.openfeetpopup !== 'function') {
  window.openfeetpopup = function () {
    openMiniSplitPopup('feet-modal');
  };
}

if (typeof window.openzonepopup !== 'function') {
  window.openzonepopup = function () {
    openMiniSplitPopup('zone-modal');
  };
}

if (typeof window.Qtyminus !== 'function') {
  window.Qtyminus = function (button) {
    var input = button.parentElement.querySelector('input');
    if (!input) return;

    var currentValue = parseInt(input.value, 10) || 0;
    input.value = Math.max(0, currentValue - 1);
  };
}

if (typeof window.Qtyplus !== 'function') {
  window.Qtyplus = function (button) {
    var input = button.parentElement.querySelector('input');
    if (!input) return;

    var currentValue = parseInt(input.value, 10) || 0;
    input.value = currentValue + 1;
  };
}

if (typeof window.scrollToBuildStepTop !== 'function') {
  window.scrollToBuildStepTop = function () {
    var buildWrapper = document.querySelector('.build_split_wrapper');
    if (!buildWrapper) return;

    buildWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
}
}());

const MiniSplitBuilder = (function () {
  const productCache = {};
  const roomProductFields = [
    { field: 'airhandler', role: 'air-handler', section: 'Indoor Air Handlers' },
    { field: 'lineset', role: 'line-set', section: 'Line Sets / Installation Components' },
    { field: 'second_lineset', role: 'line-set', section: 'Line Sets / Installation Components' },
    { field: 'coupler', role: 'coupler', section: 'Couplers / Extensions' }
  ];
  const roomProductSectionOrder = ['Indoor Air Handlers', 'Line Sets / Installation Components', 'Couplers / Extensions'];
  const accessoryProductFields = ['product_1', 'product_2', 'product_3', 'product_4', 'product_5', 'product_6', 'product_7', 'product_8', 'product_9', 'product_10'];
  const singleZoneChoiceLabels = ['Good Value', 'Most Popular', 'Premium'];

  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error('Mini split builder config could not be parsed.', error);
      return fallback;
    }
  }

  function parseBuilderConfig() {
    const rawConfig = window.MiniSplitBuilderConfig || {};
    const legacyRoomOptions = typeof text !== 'undefined' ? parseJson(text, { options: [] }).options : [];
    const legacyCondenserOptions = typeof condenser !== 'undefined' ? parseJson(condenser, { options: [] }).options : [];
    const legacyAccessoryRanges = typeof accessories !== 'undefined' ? parseJson(accessories, { btu_ranges: [] }).btu_ranges : [];

    return {
      roomOptions: asArray(rawConfig.roomOptions || legacyRoomOptions),
      condenserOptions: asArray(rawConfig.condenserOptions || legacyCondenserOptions),
      accessoryRanges: asArray(rawConfig.accessoryRanges || legacyAccessoryRanges)
    };
  }

  const config = parseBuilderConfig();

  function toNumber(value) {
    return parseInt(value, 10) || 0;
  }

  function getSelectedSingleBTU() {
    return $('input[type="radio"][name="single_btu"]:checked').val();
  }

  function getSelectedRooms() {
    const rooms = [];
    jQuery(".room_zone_list .room_item").each(function () {
      const $room = jQuery(this);
      const squareFootage = $room.find('[aria-label="total_btu"]').val();
      const mountType = $room.find('[aria-label="mount_type"]').val();
      const linesetLength = $room.find('[aria-label="length_in_feet"]').val();

      rooms.push({
        square_footage: squareFootage,
        mount_type: mountType,
        lineset_length: linesetLength,
        selected_option: squareFootage + '/' + mountType + '/' + linesetLength,
        option_text: $room.find('[aria-label="total_btu"] option:selected').text() + ' - ' + $room.find('[aria-label="mount_type"] option:selected').text() + ' - ' + $room.find('[aria-label="length_in_feet"] option:selected').text()
      });
    });
    return rooms;
  }

  function calculateTotalBTU(options) {
    const settings = options || {};
    const selectedSingleBTU = getSelectedSingleBTU();
    if (settings.includeSingleRoom && selectedSingleBTU) {
      return toNumber(selectedSingleBTU);
    }

    return getSelectedRooms().reduce(function (total, room) {
      return total + toNumber(room.square_footage);
    }, 0);
  }

  function formatOrdinal(number) {
    if (number === 1) return number + 'st';
    if (number === 2) return number + 'nd';
    if (number === 3) return number + 'rd';
    return number + 'th';
  }

  function formatRoomLabel(number) {
    return formatOrdinal(number) + ' Room/Zone';
  }

  function getSingleZoneChoiceLabel(productIndex, product) {
    const productTitle = product && product.title ? product.title.toLowerCase() : '';
    const isHyperHeat = productTitle.indexOf('hyper heat') !== -1;
    const isCassette = productTitle.indexOf('cassette') !== -1;

    if (isHyperHeat && isCassette) return 'Cold Climate Cassette';
    if (isHyperHeat) return 'Cold Climate';
    if (isCassette) return 'Ceiling Cassette';

    return singleZoneChoiceLabels[productIndex] || 'Additional Option';
  }

  function buildProductAjaxUrl(productUrl) {
    if (!productUrl) return '';
    if (productUrl.indexOf('view=ajax') !== -1) return productUrl;
    return productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'view=ajax';
  }

  function fetchProductData(productUrl) {
    const ajaxUrl = buildProductAjaxUrl(productUrl);
    if (!ajaxUrl) return Promise.resolve(null);
    if (productCache[ajaxUrl]) return productCache[ajaxUrl];

    productCache[ajaxUrl] = new Promise(function (resolve) {
      jQuery.ajax({
        type: "GET",
        url: ajaxUrl,
        success: function (responseText) {
          try {
            resolve(typeof responseText === 'string' ? jQuery.parseJSON(responseText) : responseText);
          } catch (error) {
            console.error('Mini split product data could not be parsed.', ajaxUrl, error);
            resolve(null);
          }
        },
        error: function (xhr, status, error) {
          console.error('Mini split product data failed to load.', ajaxUrl, status, error);
          resolve(null);
        }
      });
    });

    return productCache[ajaxUrl];
  }

  function formatMoney(value) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value, Shopify.money_format);
    }
    return value;
  }

  function getProductCardTitle(product) {
    const productTitle = product && product.title ? String(product.title).trim() : '';
    const variantTitle = product && product.variant_title ? String(product.variant_title).trim() : '';
    const titleWithoutDefaultVariant = productTitle.replace(/\s+-\s+Default Title\s*$/, '');

    if (!variantTitle || variantTitle === 'Default Title') {
      return titleWithoutDefaultVariant;
    }

    return titleWithoutDefaultVariant || variantTitle;
  }

  function renderProductCard(product, options) {
    const settings = options || {};
    const roleClass = settings.componentRole ? ' msb-component--' + settings.componentRole : '';
    const singleZoneClass = settings.singleZoneOption ? ' single-zone-option' + (settings.selected ? ' is-selected' : '') : '';
    const classes = (settings.accessory ? 'tab_prd accessory_prd scroll-trigger animate--slide-in' : 'tab_prd scroll-trigger animate--slide-in') + roleClass + singleZoneClass;
    const imageUrl = product.featured_image ? product.featured_image + '&width=500' : '';
    const displayTitle = getProductCardTitle(product);
    let dataAttributes = 'data-id="' + product.variant_id + '"';

    if (settings.index !== undefined) dataAttributes += ' data-index="' + settings.index + '"';
    if (settings.linesetLength !== undefined) dataAttributes += ' data-length="' + settings.linesetLength + '"';
    if (settings.btu !== undefined) dataAttributes += ' data-btu="' + settings.btu + '"';
    if (settings.mountType !== undefined) dataAttributes += ' data-type="' + settings.mountType + '"';
    if (settings.componentRole !== undefined) dataAttributes += ' data-component-role="' + settings.componentRole + '"';
    if (settings.singleZoneOption) dataAttributes += ' data-single-zone-option="true" data-selected="' + (settings.selected ? 'true' : 'false') + '"';

    const qtyHtml = settings.accessory ? '<div class="tab_prd_qty"><div class="accessory-qty"><button class="qty-minus" onclick="Qtyminus(this)">-</button><input type="number" readonly="readonly" value="0" class="form-control text-center fs-6"><button class="qty-plus" onclick="Qtyplus(this)">+</button></div></div>' : '';
    const labelHtml = settings.productLabel ? '<div class="single-zone-choice-label">' + settings.productLabel + '</div>' : '';
    const priceHtml = product.compare_at_price ? '<div class="tab_prd_price"><del>' + formatMoney(product.compare_at_price) + '</del><span>' + formatMoney(product.price) + '</span></div>' : '<div class="tab_prd_price"><span>' + formatMoney(product.price) + '</span></div>';

    return '<div class="' + classes + '" ' + dataAttributes + '>' + labelHtml + '<div class="tab_prd_img"><img src="' + imageUrl + '"></div><h3><a class="full-unstyled-link" href="' + product.url + '" target="_blank">' + displayTitle + '</a></h3>' + qtyHtml + priceHtml + '</div>';
  }

  function renderProductLoadError(productUrl) {
    console.warn('Mini split builder skipped a product that failed to load.', productUrl);
    return '<div class="alert alert-warning">One product could not be loaded. Please refresh and try again.</div>';
  }

  function matchCondensers(totalBTU, selectedSingleBTU) {
    return config.condenserOptions.filter(function (option) {
      const minBTU = toNumber(option.total_btu_min);
      const maxBTU = toNumber(option.total_btu_max);
      const isMultiMatch = option.total_rooms == 'multi' && totalBTU <= maxBTU && totalBTU >= minBTU;
      const isSingleMatch = selectedSingleBTU && option.total_rooms == 'single' && selectedSingleBTU == option.total_btu;
      return isMultiMatch || isSingleMatch;
    });
  }

  function getSingleZoneProductOptions(condenserOption) {
    const products = [];
    const seenUrls = [];

    asArray(condenserOption.final_products).forEach(function (productUrl, productIndex) {
      if (productUrl && seenUrls.indexOf(productUrl) === -1) {
        seenUrls.push(productUrl);
        products.push({
          url: productUrl,
          label: getSingleZoneChoiceLabel(productIndex)
        });
      }
    });

    if (!products.length && condenserOption.final_product) {
      products.push({
        url: condenserOption.final_product,
        label: ''
      });
    }

    return products;
  }

  function matchRoomProducts(room) {
    const products = [];
    config.roomOptions.forEach(function (option) {
      if (option.selected_option == room.selected_option) {
        roomProductFields.forEach(function (productField) {
          if (option[productField.field]) {
            products.push({
              url: option[productField.field],
              role: productField.role,
              section: productField.section
            });
          }
        });
      }
    });
    return products;
  }

  function matchAccessories(totalBTU) {
    const urls = [];
    config.accessoryRanges.forEach(function (range) {
      if (totalBTU <= toNumber(range.total_btu_max) && totalBTU >= toNumber(range.total_btu_min)) {
        accessoryProductFields.forEach(function (field) {
          if (range[field]) {
            urls.push(range[field]);
          }
        });
      }
    });
    return urls;
  }

  return {
    parseBuilderConfig: parseBuilderConfig,
    calculateTotalBTU: calculateTotalBTU,
    formatOrdinal: formatOrdinal,
    formatRoomLabel: formatRoomLabel,
    getSingleZoneChoiceLabel: getSingleZoneChoiceLabel,
    getProductCardTitle: getProductCardTitle,
    fetchProductData: fetchProductData,
    renderProductCard: renderProductCard,
    renderProductLoadError: renderProductLoadError,
    matchCondensers: matchCondensers,
    getSingleZoneProductOptions: getSingleZoneProductOptions,
    matchRoomProducts: matchRoomProducts,
    matchAccessories: matchAccessories,
    roomProductSectionOrder: roomProductSectionOrder,
    getSelectedRooms: getSelectedRooms,
    getSelectedSingleBTU: getSelectedSingleBTU
  };
}());

jQuery(document).ready(function () {
  
  jQuery(".tb-next").click(function () {
    let cur = $(this).closest("#tabArea").find(".tab-pan.active");
    if (jQuery(cur).next().length > 0) {
      $(".tb-prev").removeClass("hide");
      jQuery(".tab-pan").removeClass("active");
      jQuery(cur).next().addClass("active");
    }
    if (jQuery(cur).next().next().length == 0) {
      $(".tb-next").addClass("hide");
    }
    scrollToBuildStepTop();
  });

  jQuery(".zone_item").click(function (){
    jQuery('.rooms_list').html('');
    jQuery(".tab-pan.build-step").addClass('active');
    jQuery(".tab-pan.first-step").removeClass('active');
    jQuery(".zone-item--add.button").addClass('hidden');
    jQuery(".build-step .step_title").removeClass("hidden");
    jQuery(".build-step .step_title.single_room_title").addClass("hidden");
  });

  jQuery(".zone_item.single-room").click(function(){
    jQuery(".build-step .step_title").addClass("hidden");
    jQuery(".build-step .step_title.single_room_title").removeClass("hidden");
    jQuery(".rooms_list").html("<div class='single-room-options'><div><input type='radio' id='9000' value='9000' name='single_btu' checked><label for='9000'>375</label><span class='bottom-content'>Your room is between 180 & 375 Sq ft, or 9000 BTU</span></div><div><input type='radio' id='12000' value='12000' name='single_btu'><label for='12000'>500</label><span class='bottom-content' style='left:48px'>Your room is between 376 & 500 Sq ft, or 12000 BTU</span></div><div><input type='radio' id='18000' value='18000' name='single_btu'><label for='18000'>750</label><span class='bottom-content' style='left:96px'>Your room is between 501 & 750 Sq ft, or 18000 BTU</span></div><div><input type='radio' id='24000' value='24000' name='single_btu'><label for='24000'>1000</label><span class='bottom-content' style='left:144px'>Your room is between 751 & 1000 Sq ft, or 24000 BTU</span></div><div><input type='radio' id='36000' value='36000' name='single_btu'><label for='36000'>1500</label><span class='bottom-content' style='left:192px'>Your room is between 1001 & 1500 Sq ft, or 36000 BTU</span></div></div>");
  });

  jQuery(".zone_item.multiple-rooms").click(function (){
     scrollToBuildStepTop();
     var number_of_rooms = jQuery(this).attr("data-rooms");
     for(var i=1; i<=number_of_rooms; i++){
       /*$('.demo-room-div .room_item').clone().appendTo('.rooms_list');*/
       var clonedDiv = jQuery('.demo-room-div .room_item').clone();
       clonedDiv.find('.room-number').text(MiniSplitBuilder.formatOrdinal(i));
       jQuery('.rooms_list').append(clonedDiv);
     }
     var childCount = jQuery('.rooms_list').children().length;
     if(childCount < 6 && childCount > 0){
       jQuery(".zone-item--add.button").removeClass('hidden');
     }
     else{
       jQuery(".zone-item--add.button").addClass('hidden');
     }   
     check_btu_size();
     check_dropdown_value();
     jQuery('.room_zone_list select[aria-label="total_btu"]').change(function(){
       check_btu_size();
     }); 
  });

 function check_btu_size() {
  var val = MiniSplitBuilder.calculateTotalBTU();
  var childCount = jQuery('.rooms_list').children().length;

  if (val <= 61000) {
    // ✅ Normal operation (up to 61k)
    jQuery('.build-step .btn.tb-next').removeClass('hidden');
    if (childCount < 6 && childCount > 0) {
      jQuery('.zone-item--add.button').removeClass('hidden');
    } else {
      jQuery('.zone-item--add.button').addClass('hidden');
    }
    jQuery('.build-step .mb-3').addClass('hidden');
    jQuery('.build-step .alert.alert-warning').addClass('hidden');
    jQuery('.build-step .build-step-back').removeClass('hidden');
  }
  else if (val > 61000 && val <= 64000) {
    // ⚠️ Soft warning range: 61,001 to 64,000
    jQuery('.build-step .btn.tb-next').removeClass('hidden');
    jQuery('.zone-item--add.button').addClass('hidden');
    jQuery('.build-step .mb-3').removeClass('hidden');
    jQuery('.build-step .alert.alert-warning').removeClass('hidden');
    jQuery('.build-step .build-step-back').removeClass('hidden');
    jQuery('.alert-warning').html('⚠️ Your total BTU is <strong>' + ((val / 1000).toFixed(1)) + 'k</strong>. The max capacity is 64k. Please make sure your condenser supports this configuration.');
  }
  else {
    // ⛔ Over max (64k+): Block progression
    jQuery('.build-step .btn.tb-next').addClass('hidden');
    jQuery('.zone-item--add.button').addClass('hidden');
    jQuery('.build-step .mb-3').removeClass('hidden');
    jQuery('.build-step .alert.alert-warning').removeClass('hidden');
    jQuery('.build-step .build-step-back').removeClass('hidden');
    jQuery('.alert-warning').html('❌ Your total BTU is <strong>' + ((val / 1000).toFixed(1)) + 'k</strong>, which exceeds the system limit of 64k. Please reduce your zone selections.');
  }
}

  function check_dropdown_value(){
    $('.room_zone_list .room_column').each(function() {
      var $roomColumn = $(this);
      var $mountTypeSelect = $roomColumn.find('select[aria-label="mount_type"]');
      var $squareFootageSelect = $roomColumn.find('select[aria-label="total_btu"]');

      $squareFootageSelect.change(function() {
        var selectedFootageType = $(this).val();
        
        // Check if selected mount type is ceiling
        if (selectedFootageType === '24000' || selectedFootageType === '36000') {
          // Disable options with values 24000 and 36000 in Square Footage select element
          $mountTypeSelect.find('option[value="ceiling"]').prop('disabled', true);
        } else {
          // Enable options with values 24000 and 36000 in Square Footage select element
          $mountTypeSelect.find('option[value="ceiling"]').prop('disabled', false);
        }
      });
      
      $mountTypeSelect.change(function() {
        var selectedMountType = $(this).val();
        
        // Check if selected mount type is ceiling
        if (selectedMountType === 'ceiling') {
          // Disable options with values 24000 and 36000 in Square Footage select element
          $squareFootageSelect.find('option[value="24000"]').prop('disabled', true);
          $squareFootageSelect.find('option[value="36000"]').prop('disabled', true);
        } else {
          // Enable options with values 24000 and 36000 in Square Footage select element
          $squareFootageSelect.find('option[value="24000"]').prop('disabled', false);
          $squareFootageSelect.find('option[value="36000"]').prop('disabled', false);
        }
      });
    });
  }

  jQuery(".zone-item--add.button").click(function (){
    var childCount = jQuery('.rooms_list').children().length;
    var clonedDiv = jQuery('.demo-room-div .room_item').clone();
    clonedDiv.find('.room-number').text(MiniSplitBuilder.formatOrdinal(childCount + 1));
    clonedDiv.find('.room_item_inner').append('<div class="remove_room_item"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg></div>');
    jQuery('.rooms_list').append(clonedDiv);
    check_btu_size();
    jQuery('.room_zone_list select[aria-label="total_btu"]').change(function(){
      check_btu_size();
    }); 
    if(childCount === 5){
      jQuery(this).addClass('hidden');
    }
    check_dropdown_value();
    jQuery(".remove_room_item").click(function (){
      jQuery(this).closest('.room_item').remove();
      var childCount = jQuery('.rooms_list').children().length;
      if(childCount < 5){
        jQuery(".zone-item--add.button").removeClass('hidden');
      }
      else{
        jQuery(".zone-item--add.button").addClass('hidden');
      }
      check_btu_size();
      jQuery('.room_zone_list select[aria-label="total_btu"]').change(function(){
        check_btu_size();
      }); 
    });
  });

  jQuery('.build-step .tb-next').click(function () {
    jQuery(".step-progress__step.progress-review-step").addClass('active');
    jQuery('.tab_result_product').html('');
    var selectedRooms = MiniSplitBuilder.getSelectedRooms();
    var childCount = selectedRooms.length;
    var products_list_container = '';
    var currentIndex = 0;
    var val = MiniSplitBuilder.calculateTotalBTU();
    var selectedValue = MiniSplitBuilder.getSelectedSingleBTU();
    var condenserMatches = MiniSplitBuilder.matchCondensers(val, selectedValue);

    if (selectedValue != undefined) {
      var singleZoneProducts = [];
      var singleZoneProductUrls = [];
      condenserMatches.forEach(function (condenserOption) {
        MiniSplitBuilder.getSingleZoneProductOptions(condenserOption).forEach(function (productOption) {
          if (singleZoneProductUrls.indexOf(productOption.url) === -1) {
            singleZoneProductUrls.push(productOption.url);
            singleZoneProducts.push(productOption);
          }
        });
      });

      if (singleZoneProducts.length) {
        var singleZoneSelector = 'data-review-condenser="single-zone"';
        var singleZoneContainer = '<section class="msb-review-section msb-review-section--condenser scroll-trigger animate--slide-in" ' + singleZoneSelector + '>';
        singleZoneContainer += '<div class="msb-review-section__header"><span>Recommended Complete Systems</span><p>Based on your room size, these complete MRCOOL systems are compatible with your project. Compare wall-mounted and ceiling cassette options below.</p></div>';
        singleZoneContainer += '<div class="msb-review-section__body"></div></section>';
        jQuery('.tab_result_product').append(singleZoneContainer);

        var hasMultipleSingleZoneProducts = singleZoneProducts.length > 1;
        var singleZonePromises = singleZoneProducts.map(function (productOption, productIndex) {
          return MiniSplitBuilder.fetchProductData(productOption.url).then(function (product) {
            return {
              product: product,
              productOption: productOption,
              productIndex: productIndex
            };
          });
        });

        Promise.all(singleZonePromises).then(function (results) {
          var singleZoneProductContainer = '';
          var wallMountedProducts = '';
          var ceilingCassetteProducts = '';
          var selectedSingleZoneProductAssigned = false;
          results.forEach(function (result) {
            var isSelectedSingleZoneProduct = hasMultipleSingleZoneProducts && result.product && !selectedSingleZoneProductAssigned;
            if (isSelectedSingleZoneProduct) selectedSingleZoneProductAssigned = true;

            var productCard = result.product ? MiniSplitBuilder.renderProductCard(result.product, {
              componentRole: 'condenser',
              singleZoneOption: hasMultipleSingleZoneProducts,
              selected: isSelectedSingleZoneProduct,
              productLabel: hasMultipleSingleZoneProducts ? MiniSplitBuilder.getSingleZoneChoiceLabel(result.productIndex, result.product) : ''
            }) : MiniSplitBuilder.renderProductLoadError(result.productOption.url);

            if (result.product && result.product.title && result.product.title.toLowerCase().indexOf('cassette') !== -1) {
              ceilingCassetteProducts += productCard;
            } else {
              wallMountedProducts += productCard;
            }
          });

          if (wallMountedProducts) {
            singleZoneProductContainer += '<div class="msb-review-group"><div class="msb-review-group__header">Wall-Mounted Systems</div>' + wallMountedProducts + '</div>';
          }

          if (ceilingCassetteProducts) {
            singleZoneProductContainer += '<div class="msb-review-group"><div class="msb-review-group__header">Ceiling Cassette Systems</div><p>Ceiling cassette systems require compatible 230V equipment.</p>' + ceilingCassetteProducts + '</div>';
          }

          jQuery('.tab_result_product').find('[' + singleZoneSelector + '] .msb-review-section__body').html(singleZoneProductContainer);
        });
      }
    } else {
      condenserMatches.forEach(function (condenserOption, condenserIndex) {
        var condenserSelector = 'data-review-condenser="' + condenserIndex + '"';
        var condenser_product_container = '<section class="msb-review-section msb-review-section--condenser scroll-trigger animate--slide-in" ' + condenserSelector + '>';
        condenser_product_container += '<div class="msb-review-section__header"><span>Outdoor Condenser</span><p>Matched outdoor unit for the selected room count and total system capacity.</p></div>';
        condenser_product_container += '<div class="msb-review-section__body"></div></section>';
        jQuery('.tab_result_product').append(condenser_product_container);

        MiniSplitBuilder.fetchProductData(condenserOption.final_product).then(function (product) {
          var condenser_product = product ? MiniSplitBuilder.renderProductCard(product, { componentRole: 'condenser' }) : MiniSplitBuilder.renderProductLoadError(condenserOption.final_product);
          jQuery('.tab_result_product').find('[' + condenserSelector + '] .msb-review-section__body').html(condenser_product);
        });
      });
    }

    if(selectedValue == undefined){
      function processRoomsSequentially() {
          if (currentIndex < childCount) {
              var room = selectedRooms[currentIndex];
              var productMatches = MiniSplitBuilder.matchRoomProducts(room);
              var productPromises = productMatches.map(function (productMatch) {
                  return MiniSplitBuilder.fetchProductData(productMatch.url).then(function (product) {
                    return {
                      section: productMatch.section,
                      html: product ? MiniSplitBuilder.renderProductCard(product, {
                      index: currentIndex + 1,
                      linesetLength: room.lineset_length,
                      btu: room.square_footage,
                      mountType: room.mount_type,
                      componentRole: productMatch.role
                    }) : MiniSplitBuilder.renderProductLoadError(productMatch.url)
                    };
                  });
              });
              Promise.all(productPromises).then(function (results) {
                  var each_product_container = '<section class="msb-review-section msb-review-section--room scroll-trigger animate--slide-in">';
                  each_product_container += '<div class="msb-review-room__header"><span class="room-text">' + MiniSplitBuilder.formatRoomLabel(currentIndex + 1) + '</span><span class="selected-option-text">' + room.option_text + '</span></div>';
                  MiniSplitBuilder.roomProductSectionOrder.forEach(function (sectionName) {
                    var sectionProducts = results.filter(function (result) {
                      return result.section === sectionName;
                    });
                    if (sectionProducts.length) {
                      each_product_container += '<div class="msb-review-group"><div class="msb-review-group__header">' + sectionName + '</div>';
                      each_product_container += sectionProducts.map(function (result) {
                        return result.html;
                      }).join('');
                      each_product_container += '</div>';
                    }
                  });
                  each_product_container += '</section>';
                  products_list_container += each_product_container;
  
                  currentIndex++;
                  processRoomsSequentially();
              });
          } else {
              jQuery('.tab_result_product').append(products_list_container);
          }
      }
      processRoomsSequentially();
    }
  });

  jQuery(document).on('click', '.single-zone-option', function (event) {
    event.preventDefault();
    var option = jQuery(this);
    option.closest('.msb-review-section__body').find('.single-zone-option').removeClass('is-selected').attr('data-selected', 'false');
    option.addClass('is-selected').attr('data-selected', 'true');
  });

  jQuery(".review-step .tab_result_btn_inner .btn").click(function (){
    scrollToBuildStepTop();
    jQuery(".step-progress__step.progress-accessories-step").addClass('active');
    jQuery(".tab-pan.accessories-step").addClass("active");
    jQuery(".tab-pan.review-step").removeClass("active");
    jQuery('.accessories-list').html("");
    var total_btu_val = MiniSplitBuilder.calculateTotalBTU({ includeSingleRoom: true });
    var renderedAccessoryUrls = [];
    var renderedAccessoryVariantIds = [];
    // Protect against overlapping BTU accessory ranges returning the same accessory more than once.
    var productPromises = MiniSplitBuilder.matchAccessories(total_btu_val).filter(function (productUrl) {
      if (productUrl && renderedAccessoryUrls.indexOf(productUrl) !== -1) return false;
      if (productUrl) renderedAccessoryUrls.push(productUrl);
      return true;
    }).map(function (productUrl) {
      return MiniSplitBuilder.fetchProductData(productUrl).then(function (product) {
        return {
          product: product,
          productUrl: productUrl
        };
      });
    });
    var each_accessory_container = "";
    Promise.all(productPromises).then(function (results) {
      results.forEach(function (result) {
        if (result.product && result.product.variant_id) {
          var variantId = String(result.product.variant_id);
          if (renderedAccessoryVariantIds.indexOf(variantId) !== -1) return;
          renderedAccessoryVariantIds.push(variantId);
        }

        each_accessory_container += result.product ? MiniSplitBuilder.renderProductCard(result.product, { accessory: true, componentRole: 'accessory' }) : MiniSplitBuilder.renderProductLoadError(result.productUrl);
      });
      jQuery('.accessories-list').append(each_accessory_container);
    });
  });  

  const CheckoutContainer = document.querySelector('.btn.checkout-btn');
  if(CheckoutContainer){
    CheckoutContainer.addEventListener("click", async (evt) => {
      const checkoutButton = $('.tab_result_btn_inner .checkout-btn');
      checkoutButton.html('Processing');
      $('.checkout-cart-error').remove();
      const toAdd = [];
      const toItem = [];
      let totalChecked = 0;
      let products_count = 0;
      function showCartAddError() {
        checkoutButton.html('Proceed to Checkout');
        if (!$('.checkout-cart-error').length) {
          checkoutButton.after('<div class="alert alert-warning checkout-cart-error" role="alert">We could not add your system to the cart. Please try again.</div>');
        }
      }
      jQuery("#tabArea .tab_prd").each(function () {
        if ($(this).hasClass('single-zone-option') && !$(this).hasClass('is-selected')) {
          return;
        }

        if($(this).hasClass('accessory_prd')){
          const qty = $(this).find('.accessory-qty input').val();
          if(qty > 0){
            const accessory = {
              variant_id: $(this).attr('data-id'),
              quantity: qty,
              zone_number: $(this).attr('data-index'),
              zone_length: $(this).attr('data-length'),
              zone_btu: $(this).attr('data-btu'),
              zone_type: $(this).attr('data-type'),
            };
            toAdd.push(accessory);
            toItem.push(accessory);
          }
        }
        else{
          const accessory = {
            variant_id: $(this).attr('data-id'),
            quantity: 1,
            zone_number: $(this).attr('data-index'),
            zone_length: $(this).attr('data-length'),
            zone_btu: $(this).attr('data-btu'),
            zone_type: $(this).attr('data-type'),
          };
          toAdd.push(accessory);
          toItem.push(accessory);
        }
        totalChecked++;
        products_count++;
      });
      let itemCnt = 0;
      if (!toAdd.length) {
        showCartAddError();
        return;
      }
      function moveAlong() {
        if (toAdd.length) {
          const request = toAdd.shift();
          const tempId = request.variant_id;
          const tempQty = request.quantity;
          const tempNumber = request.zone_number;
          const tempLength = request.zone_length;
          const tempBTU = request.zone_btu;
          const tempType = request.zone_type;
          var data = {
            id: tempId,
            quantity: tempQty,
            properties:{'Zone Number':tempNumber,'Zone Lineset Length':tempLength,'Zone BTU':tempBTU,'Zone Mounting':tempType}
          };
          var xhr = new XMLHttpRequest();
          xhr.open("POST", "/cart/add.js");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.responseType = "json";
          
          xhr.onload = function() {
            if (xhr.status < 200 || xhr.status >= 300) {
              showCartAddError();
              return;
            }

            itemCnt++;
            if (toItem.length === itemCnt) {
              checkoutButton.html('Proceed to Checkout');
              window.location.href = "/checkout";
            } else {
              moveAlong();
            }
          };
          xhr.onerror = showCartAddError;
          xhr.ontimeout = showCartAddError;
          xhr.send(JSON.stringify(data));
        }
      }
      moveAlong();
    });
  }

  jQuery(".build-step-back").click(function (){
    jQuery(".tab-pan.build-step").removeClass('active');
    jQuery(".tab-pan.first-step").addClass('active');
  });

  $(".tb-prev").click(function () {
    let cur = $(this).closest("#tabArea").find(".tab-pan.active");
    if (jQuery(cur).prev().length > 0) {
      $(".submitbtn").addClass("hide");
      $(".tb-next").removeClass("hide");
      jQuery(".tab-pan").removeClass("active");
      jQuery(cur).prev().addClass("active");
    }
    if (jQuery(cur).prev().prev().length == 0) {
      $(".tb-prev").addClass("hide");
    }
    scrollToBuildStepTop();
  });

  $(".review-step .tb-prev").click(function(){
    $(".step-progress__step.progress-review-step").removeClass('active');
  });

  $(".accessories-step .tb-prev").click(function(){
    $(".step-progress__step.progress-accessories-step").removeClass('active');
  })
});
